module.exports = __webpack_public_path__ + "img/20180815_145911_036.9f780862.jpg";